import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  roundtripSimple: {
    width: 100,
    height: 100,
    d: `M50,2.507C23.77,2.507,2.507,23.77,2.507,50S23.77,97.493,50,97.493
  		S97.493,76.23,97.493,50S76.23,2.507,50,2.507z M20.156,42.053h7.313c0.278-13.201,10.273-23.849,22.528-23.849
  		c8.374,0,16.014,5.002,19.94,13.056l0.542,1.111h-9.226l-0.232-0.308c-2.764-3.676-6.782-5.784-11.024-5.784
  		c-7.808,0-14.175,7.028-14.44,15.774h7.276c1.579,0,2.409,1.873,1.349,3.043L32.844,57.61c-0.723,0.798-1.976,0.798-2.698,0
  		L18.807,45.095C17.747,43.925,18.577,42.053,20.156,42.053z M79.844,57.817H72.37c-0.214,13.261-10.235,23.98-22.531,23.98
  		c-8.374,0-16.015-5.002-19.94-13.056l-0.541-1.111h9.225l0.232,0.308c2.764,3.676,6.782,5.784,11.024,5.784
  		c7.847,0,14.241-7.098,14.447-15.905H57.16c-1.579,0-2.409-1.873-1.349-3.043l11.342-12.519c0.723-0.798,1.976-0.798,2.698,0
  		l11.342,12.519C82.253,55.944,81.423,57.817,79.844,57.817z`,
  },
});
